<template>
  <div class="hype w-full">
    <Multiselect
      v-model="selectedNetwork"
      :options="networks"
      :can-deselect="false"
      :can-clear="false"
      value-prop="short_name"
      ref="network_select"
      @select="switchNetwork"
      :key="refresh"
      class="small rounded"
    >
      <template v-slot:singlelabel="{ value }">
        <div class="multiselect-single-label gap-2">
          <img class="h-4 w-4 object-contain" :src="value.logo" />
          <div class="uppercase">{{ value.short_name }}</div>
        </div>
      </template>

      <template v-slot:option="{ option }">
        <img
          class="-ml-1 mr-1 h-4 w-4 object-contain"
          :src="option.logo"
        />
        <span class="uppercase text-xs">{{ option.short_name }}</span>
      </template>
    </Multiselect>
  </div>
</template>

<script>
import Multiselect from "@vueform/multiselect";
import { mapGetters, mapState, mapActions } from "vuex";

export default {
  name: "NetworkSelect",

  components: {
    Multiselect,
  },

  emits: ["update:modelValue"],

  data() {
    return {
      refresh: false,
    };
  },

  computed: {
    ...mapGetters(["isConnected", "activeNetwork"]),
    ...mapState({
      networks: ({ main }) => main.networks,
    }),
    selectedNetwork: {
      get() {
        return this.activeNetwork.short_name;
      },
      set() {},
    },
  },

  methods: {
    ...mapActions(["setSelectedNetwork"]),
    async switchNetwork(value) {
      this.refresh = false;
      let network = this.networks.find((n) => n.short_name == value);
      try {
        await this.setSelectedNetwork(network.short_name);

        if (!this.isConnected) {
          return;
        }
        await window.ethereum.request({
          method: "wallet_switchEthereumChain",
          params: [
            {
              chainId: `0x${network.chain_id.toString(16)}`,
            },
          ],
        });
      } catch (err) {
        if (err.code == 4001) {
          this.refresh = true;
        }
        if (err.code == 4902) {
          await window.ethereum.request({
            method: "wallet_addEthereumChain",
            params: [
              {
                chainId: `0x${network.chain_id.toString(16)}`,
                chainName: network.name,
                rpcUrls: [network.rpc_url],
                nativeCurrency: {
                  ...network.native_currency,
                },
              },
            ],
          });
        }
      }
    },
  },
};
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
